import React from "react";
import Post from "./post";
import * as firebase from "firebase/app";
import { useCollectionData } from "react-firebase-hooks/firestore";

const PostList = (props) => {
  const db = firebase.firestore();

  let queryPlatform = props.selectPlatform;
  let queryLevel = props.selectLevel;
  let queryGame = props.selectGame;

  let searchPlatform = "empty";
  let searchGame = "game";
  let searchLevel = "empty";

  if (queryPlatform === "") {
    queryPlatform = "empty";
  } else {
    searchPlatform = "platform";
  }
  if (queryLevel === "") {
    queryLevel = "empty";
  } else {
    searchLevel = "level";
  }

  const [resultQuery] = useCollectionData(
    db
      .collection("posts")
      .where(searchPlatform, "==", queryPlatform)
      .where(searchGame, "==", queryGame)
      .where(searchLevel, "==", queryLevel)
  );

  return (
    <>
      {resultQuery && resultQuery.length > 0 ? (
        <ul>
          {resultQuery.map((resultPost, key) => (
            <Post
              key={key}
              resultPost={resultPost}
              searchBool="true"
              disconnected={props.disconnected}
              valueUserInfo={props.valueUserInfo}
              userId={props.userId}
              setAuthFormTrigger={props.setAuthFormTrigger}
              setLogInTrigger={props.setLogInTrigger}
            />
          ))}
        </ul>
      ) : (
        <p>
          La recherche n'a trouvé aucun résultat, essaye d'étendre ta recherche
          ou créer toi-même une annonce.
        </p>
      )}
    </>
  );
};

export default PostList;
